import { useEffect } from 'react'
import { ControlSize } from 'types'
import { PortalTooltipContext } from 'ui'
import { useRecents } from './hooks/use-recents'
import { useUserData } from './hooks/use-user-data'
import Recents from './recents'
import { Avatar, Input } from './style'
import { RecentsButtonOptions, RecentsTooltipOptions } from './types'

type Props = {
    buttonOptions?: Partial<RecentsButtonOptions>
    className?: string
    placeholder?: string
    showRecents?: boolean
    size: ControlSize
    tooltipOptions?: Partial<RecentsTooltipOptions>
    username?: string
    onChange: (username: string) => void
}

const UsernameField = ({
    buttonOptions,
    className,
    placeholder,
    showRecents = false,
    size,
    tooltipOptions,
    username = '',
    onChange,
}: Props) => {
    const [recents, addRecent] = useRecents(5)
    const [data, loading] = useUserData(username)

    useEffect(() => {
        if (data && showRecents) {
            addRecent(data)
        }
    }, [data])

    return (
        <PortalTooltipContext>
            <div className={className}>
                <Input $size={size} defaultValue={username} placeholder={placeholder} size={size} onChange={onChange}>
                    <Avatar loading={loading} size={size} source={data?.avatar} />
                    {showRecents && (
                        <Recents
                            buttonOptions={buttonOptions}
                            recents={recents}
                            size={size}
                            tooltipOptions={tooltipOptions}
                            username={username}
                            onRecentClick={onChange}
                        />
                    )}
                </Input>
            </div>
        </PortalTooltipContext>
    )
}

export default UsernameField
